import Chart from 'chart.js/auto';
const labels = [
  '1月',
  '2月',
  '3月',
  '4月',
  '5月',
  '6月',
  '7月',
  '8月',
  '9月',
  '10月',
  '11月',
  '12月',
];

const data = {
  labels: labels,
  datasets: [
    {
      label: "登録",
      backgroundColor: 'rgba(34, 178, 178)',
      borderColor: 'rgba(34, 178, 178)',
      data: [4, 3, 2, 1, 1, 1, 0, 2, 1, 3, 4, 1],
    },
    {
      label: "解除",
      backgroundColor: 'rgba(222, 54, 86, 1)',
      borderColor: 'rgba(222, 54, 86, 1)',
      data: [-4, -3, -2, -1, -1, 0, -1, -1, -2, -1, -2, -3],
    },
  ],
};

const options = {
  plugins: {
    tooltip: {
      enabled: false
    },
    legend: {
      display: false
    },
  },
  datasets: {
    bar: {
      barWidth: 31,
      barPadding: -31,
      categoryPercentage: 1,
      barPercentage: 0.5,
    }
  },
  scales: {
    yAxis: {
      stacked: true,
      ticks: {
        color: '#0A1222',
        padding: 13,
        font: {
          size: 13,
          family: "'Outfit', 'Noto Sans JP'"
        }
      },
      grid: {
        drawBorder: false
      }
    },
    xAxis: {
      stacked: true,
      ticks: {
        color: '#0A1222',
        padding: 13,
        font: {
          size: 13,
          family: "'Outfit', 'Noto Sans JP'"
        }
      },
      grid: {
        display: false,
        stacked: false,
        gridLines: {
          display: false
        }
      }
    }
  }
};

const config = {
  type: 'bar',
  data: data,
  options: options,
};

const target = document.getElementById('js-reader-chart') as HTMLCanvasElement;
if (target) {
  const myChart = new Chart(target, (config as any));
}
